// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3R914","selects":"Documents_selects__2eCC-"};